<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link
              :to="{
                name: 'View Usage Rating',
                params: { id: id },
              }"
              class="mt-2"
            >
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h2>{{ $t("setup.label.UsageRateBalance") }}</h2>
          </li>
        </ul>
      </div>
    </div>
    <div class="vx-row less-padding">
      <vx-card>
        <table class="w-full mb-4">
          <tr>
            <td class="w-9">
              <b>{{ $t("setup.label.UOM") }}</b>
            </td>
            <td class="w-13">
              <b>{{ $t("setup.label.RUM") }}</b>
            </td>
            <td class="w-19">
              <b>{{ $t("setup.label.ImpactCategory") }}</b>
            </td>
            <td class="w-9">
              <b> {{ $t("setup.label.Resource") }}</b>
            </td>
            <td v-if="quantityTireData.tierName" class="w-13">
              <b class="capitalize"> {{ quantityTireData.tierName }}</b>
            </td>
            <td class="w-9">
              <b>{{ $t("setup.label.Unit") }}</b>
            </td>
            <td class="w-9">
              <b>{{ $t("setup.label.Rate") }}</b>
            </td>
            <td class="w-9">
              <b>{{ $t("setup.label.Validity") }}</b>
            </td>
            <td class="w-9">
              <b>{{ $t("setup.label.Action") }}</b>
            </td>
          </tr>
          <tr>
            <td class="w-9">
              <v-select
                label="uomName"
                v-model="price.uom"
                :options="ReportsData.UomDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
                :clearable="false"
              >
              </v-select>
            </td>
            <td class="w-13">
              <v-select
                label="rumName"
                v-model="price.rum"
                :options="ReportsData.RumDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
                :clearable="false"
              >
              </v-select>
            </td>
            <td class="w-19">
              <v-select
                label="mCodeValue"
                v-model="price.impact"
                :options="ReportsData.impactCategoryDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
                :clearable="false"
              >
                <template v-slot:option="option">{{
                  option.mCodeValue
                }}</template>
              </v-select>
            </td>
            <td class="w-9">
              <v-select
                label="code"
                v-model="price.currencyId"
                :options="ReportsData.currencyDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
                :clearable="false"
              >
              </v-select>
            </td>
            <td class="w-13" v-if="quantityTireData.tierName">
              <v-select
                label="stepName"
                v-model="price.stepId"
                :options="quantityTireData.stepsDetailData"
                :placeholder="$t('placeholder.label.SelectOne')"
                :clearable="false"
              >
              </v-select>
            </td>
            <td class="w-9">
              <vs-input
                class="w-full mb-2 font-semibold padding-zero"
                v-model="price.unit"
              />
            </td>
            <td class="w-9">
              <vs-input
                class="w-full mb-2 font-semibold padding-zero"
                v-model="price.price"
              />
            </td>
            <td class="w-9">
              <v-select
                label="mCodeValue"
                v-model="price.validity"
                :options="ReportsData.validityDatas"
                :placeholder="$t('placeholder.label.SelectOne')"
                :clearable="false"
              >
              </v-select>
            </td>
            <td class="w-9 pl-6">
              <feather-icon
                icon="PlusIcon"
                title="add"
                svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                @click.stop="editPrices"
                class="icon_row"
              />
            </td>
          </tr>
          <tr></tr>
        </table>
        <hr />
        <div class="vx-row less-padding">
          <div class="vx-col w-3/5 less-padding">
            <div class="vx-row border-left heading">
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.UOM") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.RUM") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.ImpactCategory") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.Resource") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.TierName") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                {{ $t("setup.label.StepName") }}
              </div>
            </div>
          </div>
          <div class="vx-col w-2/5 less-padding">
            <div class="vx-row border-left heading" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                {{ $t("setup.label.Unit") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                {{ $t("setup.label.Rate") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                {{ $t("setup.label.Validity") }}
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                {{ $t("setup.label.Action") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="vx-row less-padding pt-2 pb-2 border-left"
          :key="index"
          :data="price"
          v-for="(price, index) in viewusagebalance"
        >
          <div class="vx-col w-3/5 less-padding">
            <div class="vx-row py-2" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <template v-if="price.isEditing">
                  <v-select
                    label="uomName"
                    v-model="price.uomName"
                    :clearable="false"
                    :options="ReportsData.UomDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                  </v-select>
                </template>
                <template v-else>
                  {{ price.uomName }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <template v-if="price.isEditing">
                  <v-select
                    label="rumName"
                    v-model="price.rumName"
                    :clearable="false"
                    :options="ReportsData.RumDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                  </v-select>
                </template>
                <template v-else>
                  {{ price.rumName }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <template v-if="price.isEditing">
                  <v-select
                    label="mCodeValue"
                    v-model="price.impactCategory"
                    :clearable="false"
                    :reduce="(mCodeValue) => mCodeValue"
                    :options="ReportsData.impactCategoryDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                </template>
                <template v-else>
                  {{
                    price.impactCategory.length > 13
                      ? price.impactCategory.slice(0, 10) + "..."
                      : price.impactCategory
                  }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <template v-if="price.isEditing">
                  <v-select
                    label="code"
                    v-model="price.currencyName"
                    :clearable="false"
                    :options="ReportsData.currencyDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                  </v-select>
                </template>
                <template v-else>
                  {{ price.currencyName }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <template v-if="price.isEditing">
                  <vs-input
                    v-model="price.tierName"
                    class="w-full mb-5 font-semibold tierInput"
                    :disabled="checkRatingType"
                  />
                </template>
                <template v-else>
                  {{ price.tierName ? price.tierName : "-" }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
                <template v-if="price.isEditing">
                  <v-select
                    label="stepName"
                    v-model="price.stepName"
                    :clearable="false"
                    :options="quantityTireData.stepsDetailData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :disabled="checkRatingType"
                  >
                  </v-select>
                </template>
                <template v-else>
                  {{ price.stepName ? price.stepName : "-" }}
                </template>
              </div>
            </div>
          </div>
          <div class="vx-col w-2/5 borderNone less-padding">
            <div class="vx-row py-2" style="height: 100%">
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <template v-if="price.isEditing">
                  <vs-input
                    v-model="price.unit"
                    class="w-full mb-5 font-semibold tierInput"
                  />
                </template>
                <template v-else>
                  {{ price.unit }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <template v-if="price.isEditing">
                  <vs-input
                    v-model="price.rate"
                    class="w-full mb-5 font-semibold tierInput"
                  />
                </template>
                <template v-else>
                  {{ price.rate }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <template v-if="price.isEditing">
                  <v-select
                    label="mCodeValue"
                    v-model="price.validity"
                    :clearable="false"
                    :options="ReportsData.validityDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                  </v-select>
                </template>
                <template v-else>
                  {{ price.validityName }}
                </template>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4">
                <template v-if="price.isEditing">
                  <feather-icon
                    :title="$t('setup.label.Save')"
                    icon="CheckIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current"
                    class="ml-4 pt-4 icon_row"
                    @click="updateUsageRateData(price)"
                  />
                </template>
                <feather-icon
                  v-else
                  :title="$t('setup.label.Edit')"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 stroke-current orange_icon"
                  class="ml-4 pt-3 icon_row"
                  @click="toggleEdit(price)"
                />
                <feather-icon
                  :title="$t('setup.label.Delete')"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 stroke-current orange_icon"
                  class="ml-4 pt-3 icon_row"
                  @click="
                    editJobsPopup = true;
                    delId = price.ratebalanceId;
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="'Delete ' + $t('setup.label.UsageRateBalance')"
            :active.sync="editJobsPopup"
            class="popup-close small-popup"
          >
            <div class="center">
              <img src="@/assets/images/pages/delete.svg" />
              <div class="success-msg">{{$t("setup.label.Are_you_sure_you_want_to_delete_?")}}</div>
            </div>

            <div class="center">
              <span class="p-2">
                <vs-button type="border" @click="editJobsPopup = false">{{
                  $t("setup.label.Cancel")
                }}</vs-button></span
              >

              <span class="p-2">
                <vs-button @click="deleteUsageRate(delId)">{{
                  $t("setup.label.Confirm")
                }}</vs-button>
              </span>
            </div>
            <div style="height: 20px"></div>
          </vs-popup>
        </div>
      </vx-card>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
const ReportsEmptyObj = {
  planDesc: "",
  product: "",
  charge: "",
  rumName: "",
  eventRecordType: "",
  timeModelName: "",
  zoneType: "",
  ratePlanName: "",
  regionDatas: [],
  stepName: "",
  startRange: "",
  endRange: "",
  resourceId: "",
  tierName: "",
  usageRateplanId: "",
};
const priceEmptyObj = {
  chargeCode: "",
  chargeOwner: "",
  chargevariant: "",
  currencyId: "",
  discountId: "",
  isPrepaid: "",
  locale: "en",
  planCode: "",
  price: "",
  validity: "",
  stepId: "",
  priceregion: "",
  productId: "",
  duration: "",
  roundingType: "",
  glId: "",
  impact: "",
  uom: "",
  rum: "",
  unit: "",
  checkRatingType: false,
};
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      delId: "",
      editJobsPopup: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      viewusagebalance: [],
      id: null,
      timePeriodId: null,
      editPopupYear: false,
      price: { ...priceEmptyObj },
      usageRate: {},
      priceList: [],
      Reports: { ...ReportsEmptyObj },
    };
  },
  computed: {
    ...mapState({
      viewusagebalancedetails: (state) =>
        state.usageRating.viewusageratingbalance,
      ReportsData: (state) => state.usageRating.GetUsageTemplate,
      quantityTireData: (state) => state.usageRating.quantityTireData,
    }),
  },
  methods: {
    toggleEdit(price) {
      this.$set(price, "isEditing", !price.isEditing);
    },
    async getPlanBalance() {
      try {
        await this.$store.dispatch(
          "usageRating/setviewUsageRateBalance",
          this.id
        );
        this.viewusagebalance = this.viewusagebalancedetails.map((item) => ({
          ...item,
          isEditing: false,
        }));
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateUsageRateData(price) {
      const payload = {
        id: price.ratebalanceId,
        data: {
          ratePlanId: this.usageRate.ratePlanId,
          timeperiodId: price.timePeriodId,
          locale: "en",
          rumId: price.rumName.rumId,
          uomId: price.uomName.uomId,
          impactCategory: price.impactCategory.mCodeValue,
          currencyId: price.currencyName ? price.currencyName.id : "",
          unit: price.unit,
          rate: price.rate,
          validity: price.validity ? price.validity.id : "",
        },
      };
      if (this.usageRate.ratingType != "Continous") {
        payload.data.stepId = price.stepName.stepId;
        payload.data.tierId = price.tierId;
      }
      try {
        await this.$store.dispatch("usageRating/updateUsageRate", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Usage Rate Balance Updated Successfully!",
          type: "success",
        });
        price.isEditing = false;
        this.getPlanBalance();
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async deleteUsageRate(ratebalanceId) {
      await this.$store.dispatch(
        "usageRating/delateUsageRateAction",
        ratebalanceId
      );
      this.editJobsPopup = false;
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Usage Rate Deleted Successfully!",
        type: "success",
      });
      this.getPlanBalance();
    },
    planName() {
      this.productOptions = this.Reports.planDesc.products;
      this.chargeCodes = this.Reports.planDesc.chargeCodes;
    },
    async editPrices() {
      if (!this.price.currencyId || !this.price.price || !this.price.unit) {
        this.$swal({
          title: "Opps!",
          icon: "warning",
          text: "Please fill all required fields!",
          type: "warning",
        });
        return;
      }
      this.priceList = [...this.priceList, { ...this.price }];
      this.price = {
        chargeCode: "",
        chargeOwner: "",
        chargevariant: "",
        currencyId: "",
        discountId: "",
        isPrepaid: "",
        locale: "en",
        planCode: "",
        stepId: "",
        price: "",
        priceregion: "",
        productId: "",
        duration: "",
        roundingType: "",
        glId: "",
        impact: "",
        uom: "",
        unit: "",
      };
      const payload = {
        locale: "en",
        ratebalance: [],
      };
      payload.ratebalance = this.priceList.map((el) => {
        return {
          validity: el.validity,
          currencyId: el.currencyId.id,
          glId: el.glId.id,
          uomId: el.uom.uomId,
          rumId: el.rum.rumId,
          unit: el.unit,
          rate: el.price,
          timeperiodId: this.timePeriodId,
          stepId: el.stepId.stepId,
          tierId: this.quantityTireData.tierId,
          impactCategory: el.impact.mCodeValue,
          ratePlanId: this.id,
        };
      });
      try {
        await this.$store.dispatch(
          "usageRating/createUsageRateBalance",
          payload
        );
        this.editPopupYear = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Create Successful!",
          type: "success",
        });
        this.getPlanBalance();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.routeHold = true;
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.timePeriodId = this.$route.params.timePeriodId;
    this.usageRate = this.$route.params.data;
    this.checkRatingType = !(this.usageRate.ratingType != "Continous");
    await this.$store.dispatch("usageRating/setUsageTemplate");
    if (this.usageRate && this.usageRate.ratingType != "Continous") {
      await this.$store.dispatch("usageRating/quantityTireAction", this.id);
    }
    await this.getPlanBalance();
  },
};
</script>
<style lang="scss" scoped>
.mid-popup .vs-popup {
  width: 1200px;
  max-width: 100%;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.popup-example table td {
  vertical-align: middle;
}
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  /* width: 100px; */
  font-size: 14px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 60px;
  font-size: 14px;
}
.price-table >>> .vs-table-text {
  display: block !important;
}
.footerButton-nextusage {
  width: 212px;
  height: 38px;
  top: 18px;
}
.w-13 {
  width: 13%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 5%;
  }
}
.vs__selected-options {
  overflow: hidden;
}
.normal-table tr {
  td {
    &:not(:last-child) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
    border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
    padding: 5px;
  }
  text-align: center;
}
.capitalize {
  text-transform: capitalize;
}
</style>
<style scoped>
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  width: 100px;
  font-size: 12px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 80px;
  font-size: 12px;
}
::v-deep .vs--searchable .vs__dropdown-toggle {
  height: 40px;
}
::v-deep .vs-table-text {
  display: block;
}
::v-deep .vs__selected {
  text-wrap: nowrap;
}
.less-padding .vx-row > .vx-col {
  padding: 0 1rem;
}
::v-deep .vs-table--not-data {
  display: none;
}
</style>
<style lang="scss" scoped>
.w-13 {
  width: 8.5%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 4%;
  }
}
.w-9 {
  width: 6%;
  padding: 0 4px;
  max-width: 60px;
  &:last-child {
    width: 3%;
  }
}
.w-19 {
  width: 12%;
  padding: 0 4px;
  max-width: 100px;
  &:last-child {
    width: 4%;
  }
}
.border-left {
  border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  div {
    &:not(:first-child) {
      border-left: 1px solid rgba(var(--vs-primary), 0.3);
    }
    &:nth-child(6) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
  }
}
.heading {
  font-weight: 600;
  font-size: 0.9rem;
  div {
    padding: 0.5rem 5px !important;
  }
}
.margin-bottom {
  width: 100%;
  border-bottom: 1px solid #777;
  margin-bottom: 20px;
}
.borderNone {
  border: none !important;
}
</style>
